module.exports = __webpack_public_path__ + "img/sort_arrow_up.ad8bddce.svg";